// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetHydrantByIdRequestModel from '../../model/get-hydrant-by-id-request-model';
import GetHydrantByIdRequestDTO from '../dto/get-hydrant-by-id-request-dto';
import dtoSchema from '../schemas/get-hydrant-by-id-request-schema';

export default abstract class GetHydrantByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetHydrantByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetHydrantByIdRequestDTO>): GetHydrantByIdRequestModel;
  static toModel(dto: DeepPartial<GetHydrantByIdRequestDTO> | undefined | null): GetHydrantByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetHydrantByIdRequestDTO> | undefined | null): GetHydrantByIdRequestModel | undefined {
    return dto ? new GetHydrantByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetHydrantByIdRequestModel> | GetHydrantByIdRequestModel): GetHydrantByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetHydrantByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetHydrantByIdRequestModel, can not map to GetHydrantByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
